<div class="row filter-row align-items-end">
  <div class="col-sm form-group">
    <p>{{'COMMON.ORGANISATIONS' | translate}}</p>
    <select class="form-select form-control" [ngModel]="selectedOrganisation" (ngModelChange)="onOrganisationChanged($event)">
      <option *ngFor="let organisation of organisations" [ngValue]="organisation">{{ organisation.name | translate }}</option>
    </select>
  </div>
  <div class="col-sm form-group">
    <p>{{'COMMON.SITES' | translate}}</p>
    <select class="form-select form-control" [(ngModel)]="selectedSite">
      <option *ngFor="let site of sites" [ngValue]="site">{{ site.name | translate }}</option>
    </select>
  </div>
  <div class="col-sm form-group">
    <button class="btn btn-primary" type="button" (click)="getSettings()">
      {{'COMMON.UPDATE' | translate}}
    </button>
  </div>
</div>

<app-loaders *ngIf="isLoading"></app-loaders>

<div class="card" *ngIf="!isLoading">
  <div class="card-body">
    <div class="d-flex justify-content-end mb-2">
      <button type="submit" class="btn btn-primary"
              (click)="saveSettings()">
        {{ 'COMMON.SAVE_ALL' | translate }}
      </button>
    </div>

    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
      <li [ngbNavItem]="1">
        <button ngbNavLink>{{'SETTINGS.VISITOR_LIMIT.TITLE' | translate}}</button>
        <ng-template ngbNavContent>
          <app-visitor-limit [settings]="settingsData"
                                (tabChangedEvent)="tabChangedEvent($event)"></app-visitor-limit>
        </ng-template>
      </li>

      <li [ngbNavItem]="2">
        <button ngbNavLink>{{'SETTINGS.OPENING_HOURS.TITLE' | translate}}</button>
        <ng-template ngbNavContent>
          <app-opening-hours [settings]="settingsData"
                             (tabChangedEvent)="tabChangedEvent($event)"></app-opening-hours>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>

